import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { SERVICE_AREAS } from '@/data/site';
import { CITY_PAGES } from '@/data/locations';

const CITY_TO_SLUG = CITY_PAGES.reduce((acc, p) => {
  if (!acc[p.city]) acc[p.city] = p.slug;
  return acc;
}, {});

const testId = (name) => `area-${name.toLowerCase().replace(/\s+/g, '-')}`;

export default function ServiceAreas() {
  return (
    <section
      className="section-pad bg-ohana-primary text-ohana-bg overflow-hidden"
      data-testid="service-areas"
    >
      <div className="container-ohana">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5">
            <p className="overline">Service Areas</p>
            <h2 className="font-serif text-4xl md:text-5xl mt-3 leading-tight tracking-tight">
              Boots-on-the-ground across <span className="text-ohana-accent">Central Indiana.</span>
            </h2>
            <p className="mt-5 text-ohana-bg/75 text-base md:text-lg leading-relaxed">
              Headquartered in Columbus, Indiana. Bartholomew County. We service every city below on our regular route, plus the surrounding counties of Jackson, Decatur, Johnson, Brown, Shelby, and Jennings.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {SERVICE_AREAS.map((a) => {
                const slug = CITY_TO_SLUG[a];
                const content = (
                  <>
                    <MapPin className="h-4 w-4 text-ohana-accent flex-none" />
                    <span>{a}</span>
                  </>
                );
                const className =
                  'flex items-center gap-2.5 rounded-xl border border-white/15 bg-white/5 px-4 py-3.5 text-sm font-semibold backdrop-blur transition hover:bg-white/15';
                return slug ? (
                  <Link
                    key={a}
                    to={`/${slug}`}
                    className={className}
                    data-testid={testId(a)}
                  >
                    {content}
                  </Link>
                ) : (
                  <div
                    key={a}
                    className={className}
                    data-testid={testId(a)}
                  >
                    {content}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
